// Utils
import Cookies, { CookieChangeOptions, CookieChangeListener } from 'universal-cookie';
import { getCookieDomainUrl } from '~/utils/urlUtils';
import AnalyticService from './AnalyticService';

export enum CONSENT_OPTIONS {
    ANALYTICS = 'ANALYTICS',
}

export enum CONSENT_IDENTIFIERS {
    USER_CONSENT = 'user_consent', // Consent for external cookies. (Google Analytics, Facebook Pixel, etc.)
}

const cookies = new Cookies();

export interface UserConsent {
    [index: string]: boolean;
}

export default class UserConsentContext {
    static accept(userConsent: UserConsent, title: string) {
        cookies.set(title, userConsent, {
            expires: new Date(Date.now() + 31536000000), // 1 Year
            path: '/',
            domain: `${getCookieDomainUrl()}`, // Sets the domain to ".gethighered.global"
            secure: true,
            sameSite: 'strict',
        });
    }
    // User accepts all cookies from external sources
    static acceptAll() {
        UserConsentContext.acceptUserConsent(true);
    }

    // User accepts or denies all cookies from external sources
    static acceptUserConsent(consent: boolean) {
        const userConsent = {
            [CONSENT_OPTIONS.ANALYTICS]: consent,
        };
        AnalyticService.disableGoogleAnalytics(!consent);
        this.accept(userConsent, CONSENT_IDENTIFIERS.USER_CONSENT);
    }

    // Check if a user has anwsered a consent question
    static hasAnswered() {
        return Boolean(cookies.get(CONSENT_IDENTIFIERS.USER_CONSENT));
    }

    // Do not use this for consent checkboxes unless paired with hasAnswered()
    // This is because default option should be true for the purpose of running analytics on users who have not clicked anything
    // but consent checkboxes needs to be default false
    static getOption(option: CONSENT_OPTIONS) {
        const userConsent: UserConsent = cookies.get(CONSENT_IDENTIFIERS.USER_CONSENT);
        if (!userConsent) return true;
        return Boolean(userConsent[option]);
    }
    static cookie() {
        return cookies;
    }
}
